import { Avatar, Badge, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { IoIosNotifications } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import Pusher from "pusher-js";

import dummyImg from "../../assets/dummy.png";
import pfImg from "../../assets/staticImages/profImage.png";
import styles from "./Header.module.css";

import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
// import { IMG_URL } from "../../config/Apis";
import Box from "../box/Box";
import TextComponent from "../textComponent/TextComponent";
import { roles } from "../../config/roles";
import Storage from "../../utills/AsyncStorage";
import { setNotificationCount } from "../../Store/Actions/NotificationAction";
import { NotificationMiddleware } from "../../Store/Middlewares/NotificationMiddleware";

const Header = ({ onBackClick, title, collapsed, isProfile, mainHeader }) => {
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  const navigation = useNavigate();
  const { state } = useLocation();
  const channel = useRef(null);
  const user = useSelector((state) => state.AuthReducer.user);
  const notifiCounter = useSelector(
    (state) => state?.NotificationReducer?.unReadNotification
  );

  const dispatch = useDispatch();

  // const userData = useSelector((state) => state.AuthReducer.user);

  useEffect(() => {
    const initiateUnreadNotif = () => {
      let pusher = new Pusher("ac81b678f2fe61e8c6eb", { cluster: "mt1" });
      channel.current = pusher.subscribe(user.id.toString());
      channel.current.bind("App\\Events\\UnreadNotificationsCount", (data) => {
        // console.log("Counter notifi", data);
        dispatch(setNotificationCount(data?.notifications_count));
      });
      dispatch(NotificationMiddleware.getNotificationCount());
    };
    initiateUnreadNotif();

    return () => {
      if (channel?.current) {
        channel?.current?.unsubscribe();
      }
    };
  }, []);

  return (
    <div className={`${styles.mainHeaderDiv} ${mainHeader}`}>
      <div className={styles.headingDiv}>
        <Box boxClass={styles.backIcon} onClick={onBackClick}>
          {collapsed ? (
            <>
              <BiChevronRight style={{ color: "#000000", fontSize: 40 }} />
            </>
          ) : (
            <>
              <BiChevronLeft style={{ color: "#000000", fontSize: 40 }} />
            </>
          )}
        </Box>
        <TextComponent textClass={styles.heading}>
          {state?.headrTitle ? state?.headrTitle : title}
        </TextComponent>
      </div>
      {isProfile ? null : (
        <div
          style={{
            width: "120px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {role != roles.coHost && (
            <Badge count={notifiCounter} color="var(--primary-color)">
              <Box
                boxClass={styles.notificationDiv}
                onClick={() => navigation("/notifications")}
              >
                <IoIosNotifications className={styles.notificationIcon} />
              </Box>
            </Badge>
          )}

          <Avatar
            size={45}
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigation(
                role == roles.vendor ? "/Profile/VendorProfile" : "/profile"
              );
            }}
            icon={<img src={user?.image ? user?.image : dummyImg} />}
          />
        </div>
      )}
    </div>
  );
};

export default Header;
